/**
 * AdSense configuration.
 *
 * Publisher ID must match static/ads.txt and static/app-ads.txt.
 * Ad slot IDs come from AdSense → Ads → By ad unit (number only).
 * The loader script is injected on demand by utils/loadAdSense.js.
 */
const AdSenseConfig = {
  publisherId: 'ca-pub-8257685781438550',

  adSlots: {
    // Display unit under the home feed
    display: '4428642934',

    // Right sidebar. Same unit for now; give it its own unit in AdSense
    // when you want per-placement revenue reporting.
    sidebar: '4428642934',
  },

  isConfigured() {
    return /^ca-pub-\d+$/.test(this.publisherId) && /^\d+$/.test(this.adSlots.display);
  },
};

export default AdSenseConfig;
